import { useRouter } from 'next/router';
import Button from '@/shared/components/flip-ui-kit/Button';
import { MarketIdContent } from '@/shared/components/lending/MarketIdContent';
import ArrowIcon from '@/shared/icons/flip-ui-kit/large/Arrow';
import { chainflipAssetMap } from '@/shared/utils/env';
import { parsePricedAsset } from '@/shared/utils/helpers';
import { Layout } from '../../../../components/Layout';

export default function MarketId() {
  const router = useRouter();
  const asset = parsePricedAsset(router.query.asset);
  const token = chainflipAssetMap[asset];

  const ctaContent = (
    <div className="flex items-center gap-x-4">
      <Button
        icon={<ArrowIcon direction="down" />}
        iconPos="left"
        onClick={() => {
          window.open(new URL('/lending?tab=borrow', process.env.NEXT_PUBLIC_LP_URL), '_blank');
        }}
      >
        Borrow
      </Button>
      <Button
        icon={<ArrowIcon direction="up" />}
        iconPos="left"
        onClick={() => {
          window.open(new URL('/lending?tab=supply', process.env.NEXT_PUBLIC_LP_URL), '_blank');
        }}
      >
        Supply
      </Button>
    </div>
  );

  return router.isReady ? (
    <Layout
      title={`${token.symbol} lending market`}
      breadcrumbs={[
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Pools',
          href: '/pools?tab=Lending+Markets',
        },
        {
          text: `${token.chainflipId} lending market`,
        },
      ]}
    >
      <MarketIdContent
        asset={asset}
        ctaContent={ctaContent}
        prevHref="/pools?tab=Lending+Markets"
      />
    </Layout>
  ) : null;
}
